/* ============================================================================
   mt-disponibilidad.js — «Disponibilidad en Tienda»
   ----------------------------------------------------------------------------
   UNA consulta a tango-admin al abrir la ventana, con los SKU de todas las
   tallas. Cambiar la talla en el selector no vuelve a consultar. Si se cierra y
   se reabre dentro de un minuto (lo que tarda en actualizarse la API), se
   reutiliza la respuesta.

   Reglas que no se negocian:
   - Nunca se muestran cantidades (la API no las entrega, a propósito).
   - Un error NUNCA se muestra como «No disponible»: se ofrece reintentar.
   - Sin stock en el local no se muestra la dirección, para que nadie vaya a
     buscar algo que no está.
   ============================================================================ */
(function () {
  'use strict';

  var API = 'https://tango-admin-nu.vercel.app/api/publico/disponibilidad';
  var ESPERA_MAX = 8000;
  var REUSO_MS = 60000;
  var MAX_SKUS = 50;

  var ETIQUETA = {
    disponible: 'Disponible',
    pocas: 'Últimas unidades',
    online: 'Solo venta online',
    no: 'No disponible'
  };

  // ---- Modo prueba ----------------------------------------------------------
  // Con «Mostrar a las clientas» apagado, solo lo ve quien abra la ficha con
  // ?mtdispo=on (queda guardado en ese navegador; ?mtdispo=off lo borra).
  function pruebaActiva() {
    try {
      var q = new URL(window.location.href).searchParams.get('mtdispo');
      if (q === 'on') localStorage.setItem('mt_dispo', 'on');
      if (q === 'off') localStorage.removeItem('mt_dispo');
      return localStorage.getItem('mt_dispo') === 'on';
    } catch (e) {
      return false;
    }
  }

  function esperar(condicion, ms) {
    return new Promise(function (resolver) {
      var inicio = Date.now();
      (function mirar() {
        if (condicion() || Date.now() - inicio > ms) return resolver();
        setTimeout(mirar, 100);
      })();
    });
  }

  function init(root) {
    if (!root || root.dataset.mtIniciado) return;

    var visible = root.dataset.publico === 'true' ||
      root.dataset.editor === 'true' ||
      !!(window.Shopify && window.Shopify.designMode) ||
      pruebaActiva();
    if (!visible) return;

    var datos;
    try {
      datos = JSON.parse(root.querySelector('[data-mt-dispo-datos]').textContent);
    } catch (e) {
      return;
    }

    var opciones = datos.opciones || [];
    var conSku = (datos.variantes || []).filter(function (v) { return !!v.sku; });
    if (!conSku.length) return;

    root.dataset.mtIniciado = '1';
    root.hidden = false;

    var porId = {};
    conSku.forEach(function (v) { porId[String(v.id)] = v; });

    var tallaIdx = parseInt(root.dataset.sizeIndex, 10);
    var sectionId = root.dataset.section;

    var abrirBtn = root.querySelector('[data-mt-dispo-abrir]');
    var ventana = root.querySelector('[data-mt-dispo-ventana]');
    var titulo = ventana.querySelector('.mt-dispo__titulo');
    var arrastre = ventana.querySelector('[data-mt-dispo-arrastre]');
    var select = ventana.querySelector('[data-mt-dispo-talla]');
    var fija = ventana.querySelector('[data-mt-dispo-fija]');
    var estadoEl = ventana.querySelector('[data-mt-dispo-estado]');
    var direccion = ventana.querySelector('[data-mt-dispo-direccion]');
    var online = ventana.querySelector('[data-mt-dispo-online]');
    var errorEl = ventana.querySelector('[data-mt-dispo-error]');

    // Producto de una sola variante: Shopify la bautiza «Title / Default Title».
    // No hay nada que elegir y ese texto en inglés no le dice nada a la clienta.
    if (opciones.length === 1 && String(opciones[0]).toLowerCase() === 'title') {
      var etiquetaTalla = ventana.querySelector('.mt-dispo__label');
      if (etiquetaTalla) etiquetaTalla.hidden = true;
      select.hidden = true;
    }

    var volverAlBoton = true; // «Comprar online» lleva el foco a «Añadir», no aquí
    var cache = null;        // { clave, en, estados: { sku: estado } }
    var enCurso = null;      // { clave, promesa }
    var mapaActual = null;   // estados de la última consulta buena
    var fallo = false;

    // ---- Qué variante tiene elegida la clienta en la ficha ------------------
    function varianteDeLaFicha() {
      var selector = document.querySelector('product-selector:not([data-context="modal"])');
      if (selector) {
        var elegidos = Array.prototype.map.call(
          selector.querySelectorAll('input[type="radio"]:checked'),
          function (el) { return el.value; }
        );
        if (elegidos.length === opciones.length) {
          var hallada = (datos.variantes || []).filter(function (v) {
            return v.options.every(function (o, i) { return o === elegidos[i]; });
          })[0];
          if (hallada) return hallada;
        }
      }
      var form = document.getElementById('ProductForm-' + sectionId);
      var input = form && form.querySelector('input[name="id"]');
      if (input) {
        var porInput = (datos.variantes || []).filter(function (v) { return String(v.id) === String(input.value); })[0];
        if (porInput) return porInput;
      }
      try {
        var id = new URL(window.location.href).searchParams.get('variant');
        var porUrl = (datos.variantes || []).filter(function (v) { return String(v.id) === String(id); })[0];
        if (porUrl) return porUrl;
      } catch (e) {}
      return conSku[0];
    }

    // Con Color + Talla, el selector muestra las tallas del color elegido: una
    // lista de «Negro / 38, Negro / 40, Beige / 38…» sería eterna en el teléfono.
    function tallasDelGrupo(base) {
      if (tallaIdx < 0 || opciones.length < 2) return conSku;
      var grupo = conSku.filter(function (v) {
        return v.options.every(function (o, i) { return i === tallaIdx || o === base.options[i]; });
      });
      return grupo.length ? grupo : conSku;
    }

    function rotulo(v, agrupado) {
      return agrupado ? v.options[tallaIdx] : v.title;
    }

    function prepararSelector(base) {
      var lista = tallasDelGrupo(base);
      var agrupado = lista !== conSku;
      select.innerHTML = '';
      lista.forEach(function (v) {
        var op = document.createElement('option');
        op.value = String(v.id);
        op.textContent = rotulo(v, agrupado);
        select.appendChild(op);
      });
      select.value = porId[String(base.id)] && lista.indexOf(porId[String(base.id)]) > -1
        ? String(base.id)
        : String(lista[0].id);

      if (agrupado) {
        var resto = [];
        opciones.forEach(function (nombre, i) {
          if (i !== tallaIdx) resto.push(nombre + ': ' + base.options[i]);
        });
        fija.textContent = resto.join(' · ');
        fija.hidden = false;
      } else {
        fija.hidden = true;
      }
      return lista;
    }

    // ---- Consulta ------------------------------------------------------------
    function skusAConsultar(grupo) {
      var todos = [];
      conSku.forEach(function (v) { if (todos.indexOf(v.sku) === -1) todos.push(v.sku); });
      if (todos.length <= MAX_SKUS) return todos;
      // Más de 50: se consultan las tallas del color elegido, que es lo que se ve.
      var delGrupo = [];
      grupo.forEach(function (v) { if (delGrupo.indexOf(v.sku) === -1) delGrupo.push(v.sku); });
      return delGrupo.slice(0, MAX_SKUS);
    }

    function consultar(skus, forzar) {
      var clave = skus.join(',');
      if (!forzar && cache && cache.clave === clave && Date.now() - cache.en < REUSO_MS) {
        return Promise.resolve(cache.estados);
      }
      if (enCurso && enCurso.clave === clave) return enCurso.promesa;

      var url = API + '?sku=' + skus.map(encodeURIComponent).join(',');
      var control = typeof AbortController === 'function' ? new AbortController() : null;

      var pedido = fetch(url, { signal: control ? control.signal : undefined, credentials: 'omit' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (j) {
          if (!j || j.ok !== true || !Array.isArray(j.items)) throw new Error('respuesta no válida');
          var estados = {};
          j.items.forEach(function (it) {
            if (it && it.sku) estados[it.sku] = it.estado;
          });
          cache = { clave: clave, en: Date.now(), estados: estados };
          return estados;
        });

      var limite = new Promise(function (_, rechazar) {
        setTimeout(function () {
          if (control) control.abort();
          rechazar(new Error('más de 8 segundos'));
        }, ESPERA_MAX);
      });

      var promesa = Promise.race([pedido, limite]);
      enCurso = { clave: clave, promesa: promesa };
      promesa.then(limpiar, limpiar);
      function limpiar() { if (enCurso && enCurso.promesa === promesa) enCurso = null; }
      return promesa;
    }

    // ---- Pintado -------------------------------------------------------------
    function estadoDe(v, mapa) {
      var e = mapa[v.sku];
      if (e === 'disponible' || e === 'pocas') return e;
      // "no_disponible", o la talla no vino en la respuesta
      return v.available ? 'online' : 'no';
    }

    function pintar(estado) {
      estadoEl.innerHTML = '';
      if (estado === 'cargando') {
        estadoEl.innerHTML = '<span class="mt-dispo__pill mt-dispo__pill--cargando"><span class="mt-dispo__oculto">Consultando disponibilidad</span></span>';
      } else if (ETIQUETA[estado]) {
        var pill = document.createElement('span');
        pill.className = 'mt-dispo__pill mt-dispo__pill--' + estado;
        pill.textContent = ETIQUETA[estado];
        estadoEl.appendChild(pill);
      }
      // La dirección solo cuando hay algo que ir a buscar (o si no pudimos
      // saberlo). Mientras carga tampoco: aparecería y desaparecería.
      direccion.hidden = !(estado === 'disponible' || estado === 'pocas' || estado === 'error');
      online.hidden = estado !== 'online';
      errorEl.hidden = estado !== 'error';
    }

    function actualizar() {
      if (fallo) return pintar('error');
      if (!mapaActual) return pintar('cargando');
      var v = porId[select.value];
      if (v) pintar(estadoDe(v, mapaActual));
    }

    function cargar(forzar) {
      var base = porId[select.value] || conSku[0];
      var skus = skusAConsultar(tallasDelGrupo(base));
      fallo = false;

      var clave = skus.join(',');
      if (!forzar && cache && cache.clave === clave && Date.now() - cache.en < REUSO_MS) {
        mapaActual = cache.estados;
        return actualizar();
      }

      mapaActual = null;
      pintar('cargando');
      consultar(skus, forzar).then(function (estados) {
        mapaActual = estados;
        actualizar();
      }, function () {
        mapaActual = null;
        fallo = true;
        actualizar();
      });
    }

    // ---- Abrir y cerrar ------------------------------------------------------
    var soportaModal = typeof ventana.showModal === 'function';

    function abrir() {
      // loading="lazy" evita bajarla si nadie abre la ventana; al abrir se pide ya.
      var foto = ventana.querySelector('.mt-dispo__foto');
      if (foto && foto.getAttribute('loading') === 'lazy') foto.setAttribute('loading', 'eager');
      prepararSelector(varianteDeLaFicha());
      if (soportaModal) ventana.showModal();
      else ventana.setAttribute('open', '');
      ventana.style.transform = '';
      titulo.focus();
      cargar(false);
    }

    function cerrar() {
      if (soportaModal && ventana.open) ventana.close();
      else if (!soportaModal) {
        ventana.removeAttribute('open');
        abrirBtn.focus();
      }
    }

    abrirBtn.addEventListener('click', abrir);
    ventana.querySelector('[data-mt-dispo-cerrar]').addEventListener('click', cerrar);
    ventana.querySelector('[data-mt-dispo-reintentar]').addEventListener('click', function () { cargar(true); });
    select.addEventListener('change', actualizar);

    // Tocar el fondo: el clic llega con el propio <dialog> como destino, porque
    // la hoja interior ocupa toda la caja visible.
    ventana.addEventListener('click', function (e) {
      if (e.target === ventana) cerrar();
    });

    ventana.addEventListener('close', function () {
      ventana.style.transform = '';
      // El evento close llega DESPUÉS de que «Comprar online» ya movió el foco a
      // «Añadir al carrito»; sin esta guarda se lo quitaba en el mismo instante.
      if (volverAlBoton) abrirBtn.focus();
      volverAlBoton = true;
    });

    // ---- Deslizar hacia abajo para cerrar (teléfono) -------------------------
    var movil = window.matchMedia('(max-width: 749px)');
    var arrastrando = null;

    arrastre.addEventListener('pointerdown', function (e) {
      if (!movil.matches || e.target.closest('button')) return;
      arrastrando = { y: e.clientY, dy: 0 };
      ventana.style.transition = 'none';
      try { arrastre.setPointerCapture(e.pointerId); } catch (err) {}
    });

    arrastre.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      arrastrando.dy = Math.max(0, e.clientY - arrastrando.y);
      ventana.style.transform = 'translateY(' + arrastrando.dy + 'px)';
    });

    function soltar() {
      if (!arrastrando) return;
      var dy = arrastrando.dy;
      arrastrando = null;
      ventana.style.transition = 'transform 0.2s ease';
      if (dy > 90) {
        cerrar();
      } else {
        ventana.style.transform = '';
      }
    }
    arrastre.addEventListener('pointerup', soltar);
    arrastre.addEventListener('pointercancel', soltar);

    // ---- «Comprar online» ----------------------------------------------------
    // Cierra la ventana, deja elegida en la ficha la talla que estaba mirando
    // y la lleva a «Añadir al carrito».
    function elegirEnLaFicha(v) {
      var i = 0;
      function radio(nombre, valor) {
        var selector = document.querySelector('product-selector:not([data-context="modal"])');
        if (!selector) return null;
        return Array.prototype.filter.call(selector.querySelectorAll('input[type="radio"]'), function (el) {
          return el.getAttribute('name') === 'options[' + nombre + ']' && el.value === valor;
        })[0] || null;
      }
      function paso() {
        if (i >= opciones.length) return Promise.resolve();
        var nombre = opciones[i];
        var valor = v.options[i];
        i++;
        var el = radio(nombre, valor);
        if (!el || el.checked) return paso();
        el.click();
        // El tema vuelve a dibujar el selector tras cada cambio: esperar a que
        // el nuevo quede marcado antes de tocar la opción siguiente.
        return esperar(function () {
          var nuevo = radio(nombre, valor);
          return nuevo && nuevo.checked;
        }, 2500).then(paso);
      }
      return paso();
    }

    function irAlCarrito() {
      var botones = Array.prototype.filter.call(document.querySelectorAll('button[name="add"]'), function (b) {
        return b.offsetParent !== null && !b.closest('product-sticky-atc');
      });
      var boton = botones[0];
      if (!boton) return;
      var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      boton.scrollIntoView({ block: 'center', behavior: suave ? 'smooth' : 'auto' });
      try { boton.focus({ preventScroll: true }); } catch (e) { boton.focus(); }
    }

    ventana.querySelector('[data-mt-dispo-comprar]').addEventListener('click', function () {
      var v = porId[select.value];
      volverAlBoton = false;
      cerrar();
      if (!v) return irAlCarrito();
      elegirEnLaFicha(v).then(irAlCarrito);
    });
  }

  function arrancar() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mt-dispo]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  } else {
    arrancar();
  }

  // Editor de temas: al cambiar un ajuste la sección se vuelve a dibujar.
  document.addEventListener('shopify:section:load', arrancar);
})();
